var _style, _g, _g2, _polygon, _polygon2, _polygon3, _polygon4, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateBorderTopGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1600.2 349.2",
    style: {
      enableBackground: "new 0 0 1600.2 349.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9E2130;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st1{fill:#F6981E;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st3{fill:#A09F9F;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st4{fill:#E2B759;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st5{fill:#DDDBDB;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st6{opacity:0.6;fill:#A37400;}\n\t.st7{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 53.6,
    cy: 53.2,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.6,73.2c-3.5,3.5-13.7-1.1-17.2-4.6s-3.5-9.1,0-12.6s9.1-3.5,12.6,0S77.1,69.7,73.6,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.3,97.6c-2.8,6.9,1.7,10.7,8.5,14.2s5.4,12.5,17.3,17.8c11.9,5.3,9.9,11.8,16,16c6,4.1,26.4,0.5,26.4,0.5 s3.7-20.3-0.5-26.4c-4.1-6-10.6-4.1-16-16s-14.4-10.5-17.8-17.3c-3.5-6.8-7.3-11.3-14.2-8.5C89.1,81.6,82,88.7,78.3,97.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.6,158.1c-2.3,8.7,3.7,16.8,9.8,18.7c6.1,1.9,19.4-2.5,20.8-14.3s-6.9-27.6-22.2-30.2 c-16.6-2.8-30.3,5.1-32.4,23.1c-2.1,18,5.4,19.8,21.7,52.9c11.9,24.2,10.8,35.4,8.5,40.6c-3.8,8.6-11.2,15.3-22.4,11.8 S37.1,248.2,39.6,240s10.7-9.3,15.2-6.7s6.2,10.1,1.8,13.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 74.5,
    cy: 160.5,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 53.8,
    cy: 243.4,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.6,73.2c-4.5,4.5-17,8.1-17,8.1s8.3,0.6,13.4,2.1s10.6,5.9,10.6,5.9s2.8-0.8,5.6-3.6s3.6-5.6,3.6-5.6 s-4.4-5.5-5.9-10.6s-2.1-13.4-2.1-13.4S78.1,68.7,73.6,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.7,113c0,0,2.7-9.5,9-15.8s15.8-9,15.8-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.9,139.2c0,0,9.5-2.7,15.8-9c6.3-6.3,9-15.8,9-15.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.4,124.1c0,0,3.5-10.3,10.6-17.5c7.1-7.1,17.5-10.6,17.5-10.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.2,108.6c0,0-9.3,2.5-15.5,8.6c-6.1,6.1-8.6,15.5-8.6,15.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.7,142.5c0,0,30.7-27.8,36.9-37.9c6.2-10.1,6-18.2,6-18.2l22.1,8.5c0,0-14.1,5.8-25.1,15.6 c-11,9.9-34.2,37.7-34.2,37.7L159.7,142.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.9,159.2c0,0-27.8,30.7-37.9,36.9c-10.1,6.2-18.2,6-18.2,6l8.5,22.1c0,0,5.8-14.1,15.6-25.1 c9.9-11,37.7-34.2,37.7-34.2L142.9,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158.6,164.6c0,0-5.4,14.1,13.4,32.9s101,75,101,75s-56.2-82.2-75-101s-33-13.4-33-13.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "161.8,161.4 158.6,164.6 148.6,164.9 142.9,159.2 143.3,149.3 146.5,146.1 149.7,142.9 159.7,142.5  165.4,148.2 165,158.1  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 154.1,
    cy: 153.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "271.2,270 248.5,255.6 158.6,164.6 165,158.1 256.1,248.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.6,67.1c8.7-2.3,16.8,3.7,18.7,9.8c1.9,6.1-2.5,19.4-14.3,20.8s-27.6-6.9-30.2-22.2 c-2.8-16.6,5.1-30.3,23.1-32.4s19.8,5.4,52.9,21.7c24.2,11.9,35.4,10.8,40.6,8.5c8.6-3.8,15.3-11.2,11.8-22.4s-12.4-14.2-20.7-11.6 c-8.2,2.5-9.3,10.7-6.7,15.2c2.5,4.4,10.1,6.2,13.7,1.8"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 160.9,
    cy: 74,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 243.8,
    cy: 53.4,
    r: 4.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1546.6,
    cy: 53.3,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1526.6,73.3c-3.5-3.5,1.1-13.7,4.6-17.2s9.1-3.5,12.6,0s3.5,9.1,0,12.6C1540.3,72.2,1530.1,76.8,1526.6,73.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1502.1,78.1c-6.9-2.8-10.7,1.7-14.2,8.5s-12.5,5.4-17.8,17.3c-5.4,11.9-11.8,9.9-16,16 c-4.1,6-0.5,26.4-0.5,26.4s20.3,3.7,26.4-0.5c6-4.1,4.1-10.6,16-16s10.5-14.4,17.3-17.8c6.8-3.5,11.3-7.3,8.5-14.2 C1518.2,88.8,1511.1,81.8,1502.1,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1441.6,67.3c-8.7-2.3-16.8,3.7-18.7,9.8c-1.9,6.1,2.5,19.4,14.3,20.8s27.6-6.9,30.2-22.2 c2.8-16.6-5.1-30.3-23.1-32.4s-19.8,5.4-52.9,21.7c-24.2,11.9-35.4,10.8-40.6,8.5c-8.6-3.8-15.3-11.2-11.8-22.4 s12.4-14.2,20.7-11.6c8.2,2.5,9.3,10.7,6.7,15.2c-2.5,4.4-10.1,6.2-13.7,1.8"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1439.3,
    cy: 74.2,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1356.4,
    cy: 53.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1526.6,73.3c-4.5-4.5-8.1-17-8.1-17s-0.6,8.3-2.1,13.4s-5.9,10.6-5.9,10.6s0.8,2.8,3.6,5.6 c2.8,2.8,5.6,3.6,5.6,3.6s5.5-4.4,10.6-5.9s13.4-2.1,13.4-2.1S1531.1,77.8,1526.6,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1486.8,88.4c0,0,9.5,2.7,15.8,9s9,15.8,9,15.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1460.6,114.6c0,0,2.7,9.5,9,15.8c6.3,6.3,15.8,9,15.8,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1475.7,96.1c0,0,10.3,3.5,17.5,10.6c7.1,7.1,10.6,17.5,10.6,17.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1491.2,132.9c0,0-2.5-9.3-8.6-15.5c-6.1-6.1-15.5-8.6-15.5-8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1457.3,159.4c0,0,27.8,30.7,37.9,36.9s18.2,6,18.2,6l-8.5,22.1c0,0-5.8-14.1-15.6-25.1 c-9.9-11-37.7-34.2-37.7-34.2L1457.3,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1440.5,142.6c0,0-30.7-27.8-36.9-37.9s-6-18.2-6-18.2l-22.1,8.5c0,0,14.1,5.8,25.1,15.6 c11,9.9,34.2,37.7,34.2,37.7L1440.5,142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1435.2,158.3c0,0-14.1-5.4-32.9,13.4s-75,101-75,101s82.2-56.2,101-75s13.4-32.9,13.4-32.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1438.4,161.5 1435.2,158.3 1434.8,148.4 1440.5,142.6 1450.5,143 1453.7,146.2 1456.9,149.5  1457.3,159.4 1451.6,165.1 1441.6,164.7  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1446.1,
    cy: 153.9,
    r: 6.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1329.7,271 1344.1,248.2 1435.2,158.3 1441.6,164.7 1351.3,255.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1532.6,158.3c2.3,8.7-3.7,16.8-9.8,18.7s-19.4-2.5-20.8-14.3s6.9-27.6,22.2-30.2c16.6-2.8,30.3,5.1,32.4,23.1 s-5.4,19.8-21.7,52.9c-11.9,24.2-10.8,35.4-8.5,40.6c3.8,8.6,11.2,15.3,22.4,11.8c11.2-3.5,14.2-12.4,11.6-20.7s-10.7-9.3-15.2-6.7 c-4.4,2.5-6.2,10.1-1.8,13.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1525.7,
    cy: 160.6,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1546.4,
    cy: 243.5,
    r: 4.5
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "629.7,34 649.7,54 629.7,74 301.4,74 281.4,54 301.4,34 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1298.8,33 1318.8,53 1298.8,73 970.5,73 950.5,53 970.5,33 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "629.7,74 301.4,74 281.4,54 649.7,54 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1298.8,74 970.5,74 950.5,54 1318.8,54 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "73,349.8 73,302.4 53.6,282.4 34.3,302.4 34.3,349.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "73,349.8 73,302.4 53.6,282.4 53.6,349.8  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1566,349.8v-47.7l-19.3-20l-19.4,20v47.7h32.6c0.1,0,0.3,0,0.4,0H1566z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1546.7,349.8 1546.8,282.1 1527.3,302.1 1527.3,349.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateBorderTopGold);
export default __webpack_public_path__ + "static/media/certificate-border-top-gold.8015dffbf0e7a663c041cbdb68e8c8ed.svg";
export { ForwardRef as ReactComponent };